import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { getTotalCollection } from "../connections/getApi";
import { setError, setLoading } from "../redux/slices/pharmacySlice";
import { useLocation } from "react-router-dom";

const UseFetchCollections = (date, status, endDate, page, itemPerPage, q) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const isEnable = location.pathname === "/pharmacy";

  return useQuery({
    queryKey: ["getTotalCollection", date, status, endDate, page, itemPerPage, q],
    queryFn: () => getTotalCollection(date, status, endDate, page, itemPerPage, q),
    enabled: isEnable && !!status && !!page && !!itemPerPage,
    onError: () => {
      dispatch(setError(true));
      dispatch(setLoading(false));
    },

    onSettled: () => {
      dispatch(setLoading(false));
    },
    // staleTime: Infinity, // Keep the data fresh indefinitely
    // cacheTime: 1000 * 60 * 60, // Cache the data for 1 hour
    // refetchOnWindowFocus: false, // Don't refetch when window regains focus
    // refetchOnReconnect: false, // Don't refetch when reconnecting
    // refetchOnMount: false, // Don't refetch on component mount
  });
};

export default UseFetchCollections;
